// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".View__phone-number--1znIt {\n  display: block;\n}\n\n.View__input--3WVYy .form-control-feedback {\n  display: none;\n}", "",{"version":3,"sources":["View.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf","file":"View.css","sourcesContent":[".phone-number {\n  display: block;\n}\n\n.input :global(.form-control-feedback) {\n  display: none;\n}"]}]);
// Exports
exports.locals = {
	"phone-number": "View__phone-number--1znIt",
	"phoneNumber": "View__phone-number--1znIt",
	"input": "View__input--3WVYy"
};
module.exports = exports;
